import { useEffect, useState } from "react";
import axios from "../../../axios";
import { useNavigate } from "react-router-dom";
import handleApiError from "../../../utils/handleApiError";
// import SuccessModal from "../../components/SuccessModal";

export default function CoverDesignListPage() {
    const [fabrics, setFabrics] = useState([]);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    // const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchFabrics();
    }, []);

    const fetchFabrics = async () => {

        setLoading(true);
        try {
            axios.get(`/admin/cover-designs`).then((res) => {
                setFabrics(res.data);
            });
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Yakin ingin menghapus fabric ini?")) return;
        await axios.delete(`/admin/cover-designs/${id}`);
        fetchFabrics();
    };

    

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-4">List Cover Designs</h4>
            </div>
            
            <div className="card-body">
                <button className="btn btn-main" onClick={() => navigate("/admin/cover-designs/create")}>+ Tambah</button>
                <table className="table table-lg table-striped w-100">
                    <thead>
                        <tr>
                            <th className="h6 text-gray-600 text-center">No</th>
                            <th className="h6 text-gray-600 text-center">Nama</th>
                            <th className="h6 text-gray-600 text-center">Gambar</th>
                            <th className="h6 text-gray-600 text-center">Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fabrics.map(fabric => (
                            <tr key={fabric.id}>
                                <td className="text-center">
                                    <span className="text-gray-600">{fabrics.indexOf(fabric) + 1}</span>
                                </td>
                                <td className="text-center">
                                    <span className="text-gray-600">{fabric.name}</span>
                                </td>
                                <td className="text-center">
                                    <span className="text-gray-600 border">{fabric.image && <img alt="" src={`http://192.168.100.18:8000/storage/${fabric.image}`} width="80"  />}</span>
                                </td>
                                
                                <td>
                                    <button className="btn btn-warning" onClick={() => navigate(`/admin/cover-designs/${fabric.id}/edit`)}>Edit</button>
                                    <button className="btn btn-danger" onClick={() => handleDelete(fabric.id)} style={{ marginLeft: "5px", color: "red" }}>Hapus</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
